export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00783.fae32dbb.png";